// Base
import { useState } from 'react'

// Packages
import htmr from 'htmr'

// Components
import {
  Accordion,
  AccordionButton,
  AccordionContent
} from '@components/helpers/accordion/Accordion'
import Section from '@components/v25/section/Section'
import { Box, Text, Flex } from 'yard-utilities/components'

// Styles
import styles from './FAQ.module.sass'

// Icons
import { PlusSignIcon } from 'icons/v25/Icons'

// Data
import faq from 'public/data/v25/ft1/faq.json'

interface FAQData {
  question: string
  answer: string
}

interface FAQProps {
  theme?: 'black' | 'white'
  padding?: number[]
}

const FAQ = ({ theme, padding = [0, 0, 64] }: FAQProps) => {
  if (faq?.length == 0) {
    return null
  }

  return (
    <Section className={styles.faq} padding={padding}>
      <Box>
        <Text
          tagName="h2"
          variant="title-2"
          align="center"
          spacing={{ sm: 32 }}
          textColor={theme == 'black' ? 'blueMagenta' : 'white'}
          transform="capitalize"
        >
          Frequently asked questions
        </Text>
      </Box>
      <Box overflow="hidden" className={styles.box}>
        {faq?.map((item: FAQData, index: number) => (
          <FAQBox question={item.question} answer={item.answer} key={index} />
        ))}
      </Box>
    </Section>
  )
}

interface FAQBoxProps {
  question: string
  answer: string
}

const FAQBox = ({ question, answer }: FAQBoxProps) => {
  const [open, setOpen] = useState(false)

  return (
    <Box
      backgroundColor={open ? 'blue-10' : 'white'}
      className={`${styles.card} ${open ? styles['open'] : ''}`}
    >
      <Accordion
        onToggle={(value: boolean) => {
          setOpen(value)
        }}
      >
        <AccordionButton>
          <Flex
            alignItems="flex-start"
            justifyContent="space-between"
            columnGap={{ sm: 24 }}
            className={styles.card__header}
          >
            <Text tagName="h3" variant="title-3" fontWeight={500}>
              {question}
            </Text>

            <div className={styles.card__plus}>
              <PlusSignIcon color="#00BAFC" />
            </div>
          </Flex>
        </AccordionButton>
        <AccordionContent>
          <Box padding={{ sm: [0, 16, 24] }}>
            <article className={styles.article}>{htmr(answer)}</article>
          </Box>
        </AccordionContent>
      </Accordion>
    </Box>
  )
}

export default FAQ
